import type { GTMEvent } from '../types/googleTags'

export const sendGTMEvent = (event: GTMEvent) => {
  if (!window.dataLayer || useRuntimeConfig().public.environment !== 'PROD')
    return

  window.dataLayer.push(event)
}
